export default __webpack_public_path__ + "static/media/loading-eclipse-200px.e830b22a.svg";